/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import React from "react"
import { ThemeProvider } from "styled-components"
import Theme from "@styles/theme"
import GlobalStyles from "@styles/global/global"
import { withAssetPrefix } from "gatsby"
import { LocationContext } from "@hooks/use-location"
import {
  registerAbExposureOnConsent,
  trackAbExposure,
} from "@utils/ab-exposure"
import "./src/fonts/typography.css"

export const wrapPageElement = ({ element, props }) => {
  return (
    <>
      <GlobalStyles />
      <ThemeProvider theme={Theme}>
        <LocationContext.Provider value={props.location}>
          {element}
        </LocationContext.Provider>
      </ThemeProvider>
    </>
  )
}

export const onRouteUpdate = () => {
  const manifestEl = document.head.querySelector(`link[rel="manifest"]`)
  if (manifestEl) {
    manifestEl.setAttribute(`href`, withAssetPrefix(`manifest.webmanifest`))
  }
  trackAbExposure()
}

export function onClientEntry() {
  registerAbExposureOnConsent()
  trackAbExposure()

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  })

  if (params.refcode) {
    document.cookie = `refcode=${params.refcode}; expires=${new Date(
      new Date().getTime() + 1000 * 60 * 60 * 24 * 90
    ).toUTCString()}; domain=klipfolio.com; path=/`
  }
}
